import axios from 'axios';
import { SharedBasketErrorCode } from './types';

const SHARED_BASKET_ERROR_CODES: SharedBasketErrorCode[] = [
  'NOT_INTENDED_RECIPIENT',
  'LINK_EXPIRED',
  'LINK_DISABLED',
  'NOT_FOUND',
];

type ErrorEnvelope = {
  error?: { code?: unknown };
};

// Branch on this, not on the HTTP status (the app 403s/404s for unrelated
// reasons) and not on `details[0].reason` (prose, not a stable key).
export const getSharedBasketErrorCode = (
  error: unknown,
): SharedBasketErrorCode | null => {
  if (!axios.isAxiosError<ErrorEnvelope>(error)) return null;

  const code = error.response?.data?.error?.code;

  return typeof code === 'string' &&
    (SHARED_BASKET_ERROR_CODES as string[]).includes(code)
    ? (code as SharedBasketErrorCode)
    : null;
};
